/**
 * Parses a bilingual JSON field that might be a string or already parsed object.
 * Used for fields like descriptionForm, nameForm, etc.
 */
export function parseBilingual(
  value: unknown
): { german?: string | null; english?: string | null } | null {
  if (!value) return null;
  if (typeof value === "object" && value !== null && "german" in value) {
    return value as { german?: string | null; english?: string | null };
  }
  if (typeof value === "string") {
    try {
      const parsed = JSON.parse(value);
      if (parsed && typeof parsed === "object" && "german" in parsed) {
        return parsed;
      }
    } catch {
      // Ignore parse errors
    }
  }
  return null;
}
